import { Component, EventEmitter, Input, Output } from '@angular/core'
import { NgClass } from '@angular/common';
import { ResponsiveComponent } from '@nx-superprep/shared'

@Component({
  selector: 'pop-ui-profile-report',
  standalone: true,
  imports: [NgClass],
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
})
export class ProfileReportComponent extends ResponsiveComponent {
  rawn9ip = ' '

  @Input() isOpen = true
  @Output() isOpenChange = new EventEmitter<boolean>()

  onClose() {
    this.isOpen = false
    this.isOpenChange.emit(this.isOpen)
  }
}
